module.exports = __webpack_public_path__ + "img/header-weddingRingsStackingRings@2x.0160fac.webp";